import React from 'react';
import { motion } from 'framer-motion';
import { Search, Wrench, HeartHandshake, TrendingUp } from 'lucide-react';
import { SERVICES } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem, cardHover } from '../../utils/animations';

const iconMap = {
  Search,
  Wrench,
  HeartHandshake,
  TrendingUp,
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.p
            className="text-brand-500 font-semibold text-sm uppercase tracking-wider mb-3"
            variants={fadeInUp}
          >
            Our Services
          </motion.p>
          <motion.h2
            className="text-3xl sm:text-4xl text-neutral-900 leading-tight"
            style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
            variants={fadeInUp}
          >
            What We Do
          </motion.h2>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {SERVICES.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <motion.div
                key={service.id}
                className="bg-white rounded-2xl p-8 border border-neutral-100 cursor-default"
                variants={staggerItem}
                whileHover={cardHover.hover}
              >
                <div className="w-12 h-12 bg-brand-100 rounded-xl flex items-center justify-center mb-5">
                  {Icon && <Icon size={24} className="text-brand-500" />}
                </div>
                <h3 className="text-lg text-neutral-900 mb-3" style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}>
                  {service.title}
                </h3>
                <p className="text-neutral-500 text-sm leading-relaxed" style={{ fontFamily: "'Livvic', sans-serif" }}>
                  {service.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;